import React, { lazy } from 'react';
import IconMetricKit from '@/assets/images/menu/icon-metrickit.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const metricKitRoutes = (): IRouteConfig[] => [
  {
    path: '/kit',
    name: 'MetricKit',
    platforms: [
      CapitalPlatform.IOS,
      CapitalPlatform.VisionOS,
    ],
    sort: 87,
    icon: <MenuIcon icon={IconMetricKit} />,
    routes: [
      {
        path: '/kit/log',
        name: '日志查询',
        component: lazy(() => import('@/presentation/pages/metric-kit/log')),
      },
    ],
  },
];

export default metricKitRoutes;
